import ActivitieItems from "../../../components/activities/activities-items";
import Form from "../../../components/form/Form";
import ActivitieContainer from "../../../components/activities/activities-container";
import {
  updateActivitie,
  getActivities,
  deleteActivitie,
} from "../../../apis/activitiesApi";
import { useState, useEffect } from "react";
import Error from "../../../components/errors-messages/Error";

import React from "react";

function Activities(props) {
  const [state, setState] = useState({
    isEditing: false,
    activities: [],
    editActivitie: null,
    editLoading: false,
    error: null,
  });

  useEffect(() => {
    loadPosts();

    // const socket = openSocket("https://shark-app-2ttko.ondigitalocean.app/website");

    // socket.on("posts", (data) => {
    //   if (data.action === "create") {
    //     addPost(data.post);
    //   } else if (data.action === "update") {
    //     updatePost(data.post);
    //   } else if (data.action === "delete") {
    //     loadPosts();
    //   }
    // });
  }, []);

  const loadPosts = async () => {
    const { data, error } = await getActivities();

    if (!data && error) {
      return setState((prevState) => {
        return {
          isEditing: false,
          activities: [],
          editActivitie: null,
          editLoading: false,
          error: error,
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        activities: data.activities,
      };
    });
  };

  const startEditPostHandler = (postId) => {
    setState((prevState) => {
      const loadedActivitie = {
        ...prevState.activities.find((p) => p._id === postId),
      };
      return {
        ...prevState,
        isEditing: true,
        editActivitie: loadedActivitie,
      };
    });
  };

  const cancelEditHandler = () => {
    setState((prevState) => {
      return {
        ...prevState,
        isEditing: false,
        editActivitie: null,
        error: null,
      };
    });
  };

  const finishEditHandler = async (activitieData) => {
    setState((prevState) => {
      return {
        ...prevState,
        editLoading: true,
      };
    });

    // const formData = new FormData();

    // formData.append("activitieName", postData.activitieName);
    // formData.append("content", postData.content);
    // formData.append("image", postData.image);
    let activitieId = state.editActivitie ? state.editActivitie._id : null;
    const { data, error } = await updateActivitie(
      props.token,
      activitieId,
      activitieData
    );
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editActivitie: null,
          editLoading: false,
          error: error,
        };
      });
    }
    const activitie = {
      _id: data.activitie._id,
      name: data.activitie.name,
      description: data.activitie.description,
    };

    setState((prevState) => {
      let updatedActivities;
      if (prevState.editActivitie) {
        updatedActivities = prevState.activities.map((c) =>
          c._id === activitie._id ? activitie : c
        );
      } else {
        updatedActivities = prevState.activities.concat(activitie);
      }
      return {
        ...prevState,
        activities: updatedActivities,
        isEditing: false,
        editActivitie: null,
        editLoading: false,
      };
    });
  };

  const newPostHandler = () => {
    setState((prevState) => {
      return {
        ...prevState,
        isEditing: true,
      };
    });
  };

  const deletePostHandler = async (postId) => {
    setState((prevState) => {
      return {
        ...prevState,
        postsLoading: true,
      };
    });
    const { data, error } = await deleteActivitie(props.token, postId);
    if ((!data, error)) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editActivitie: null,
          editLoading: false,
          error: error,
        };
      });
    }
    loadPosts();

    setState((prevState) => {
      return {
        ...prevState,
        postsLoading: false,
      };
    });
  };

  return (
    <>
      <Error error={state.error} onHandle={cancelEditHandler} />
      <Form
        editing={state.isEditing}
        currentItem={state.editActivitie}
        page={"Activitie"}
        // loading={state.editLoading}
        onCancelEdit={cancelEditHandler}
        onFinishEdit={finishEditHandler}
      />
      <ActivitieContainer
        onAddActivities={newPostHandler}
        isAuth={props.isAuth}
      >
        {state.activities.map((activitie) => (
          <ActivitieItems
            onStartEdit={startEditPostHandler.bind(this, activitie._id)}
            key={activitie._id}
            name={activitie.name}
            description={activitie.description}
            onDelete={deletePostHandler.bind(this, activitie._id)}
            isAuth={props.isAuth}
          />
        ))}
      </ActivitieContainer>
      ;
    </>
  );

  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default Activities;
